<div
  class="tw-w-full tw-min-h-xl tw-shadow-lg {{
    padding
  }} tw-bg-white tw-rounded-2xl {{ className }}"
>
  <ng-content></ng-content>
</div>
